import React, { useEffect, useState } from "react";
import {
  AssessmentSpecStatus,
  AssessmentStatus,
  UserRole,
  fullBlock,
  inviteBlock,
} from "../utils/Constants";
import { getUser } from "../redux/thunks/User";
import { useDispatch, useSelector } from "react-redux";
import { isWhiteLabelClient } from "../utils/utilities";
import { getAssessment } from "../redux/thunks/Assessment";
import UnavailableAssessment from "./UnavailableAssessment";
import TestDetails from "./dashboard/test-details/TestDetails";
import { handleMenuVisibility } from "../redux/slices/AuthSlice";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ProcessingIndicator from "../components/common/ProcessingIndicator";
import CandidateAssessFlow from "./candidate-assessment-flow/CandidateAssessFlow";
import ResumeUpload from "./candidate-assessment-flow/Assessment-concluded/ResumeUpload";
import AntiCheatContextWrapper from "../utils/contexts/candidate-flow-contexts/AntiCheatContext";
import AssessmentReview from "./candidate-assessment-flow/Assessment-concluded/AssessmentReview";
import AssessmentConcluded from "./candidate-assessment-flow/Assessment-concluded/AssessmentConcluded";
import AssessmentNotQualified from "./candidate-assessment-flow/Assessment-concluded/AssessmentNotQualified";

export default function AssessmentDetailsPage(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const auth = useSelector((state) => state.authReducer);
  const assessment = useSelector((state) => state.assessmentReducer);

  useEffect(() => {
    if (
      (auth.data?.role && auth.data?.role?.name === UserRole.CANDIDATE) ||
      (auth?.wl_settings_data?.client_id &&
        localStorage.getItem("wl_assess_id"))
    ) {
      dispatch(
        getAssessment({
          id:
            isWhiteLabelClient() && localStorage.getItem("wl_assess_id")
              ? localStorage.getItem("wl_assess_id")
              : id,
        }),
      );
    }
  }, [auth.data]);

  useEffect(() => {
    if (
      (auth?.data?.role?.name === UserRole.CANDIDATE && id) ||
      (auth?.wl_settings_data?.client_id &&
        localStorage.getItem("wl_assess_id"))
    ) {
      dispatch(handleMenuVisibility(false));
    }
  }, [auth?.data, id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  if (
    (auth.data?.role && auth.data?.role?.name === UserRole.CANDIDATE) ||
    (auth?.wl_settings_data?.client_id && localStorage.getItem("wl_assess_id"))
  ) {
    return (
      <>
        {isLoading ? (
          <>
            <div
              style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ProcessingIndicator />
            </div>
          </>
        ) : assessment?.current_assessment?.status ===
            AssessmentStatus.IN_PROGRESS ||
          assessment?.current_assessment?.status ===
            AssessmentStatus.NOT_QUALIFIED ||
          assessment?.current_assessment?.status ===
            AssessmentStatus.FINISHED ||
          (assessment?.current_assessment?.status ===
            AssessmentStatus.PENDING &&
            assessment?.current_assessment?.spec_status !== "ARCHIVED" &&
            !inviteBlock.includes(
              assessment?.current_assessment?.tenant?.status,
            ) &&
            !fullBlock.includes(
              assessment?.current_assessment?.tenant?.status,
            )) ? (
          <>
            {assessment?.current_assessment?.status ===
            AssessmentStatus.FINISHED ? (
              <>
                {isWhiteLabelClient() ? (
                  <>
                    {!assessment?.current_assessment?.resume_id ? (
                      <ResumeUpload
                        assessment={assessment?.current_assessment}
                      />
                    ) : (
                      <AssessmentConcluded
                        assessment={assessment?.current_assessment}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {!assessment?.current_assessment?.resume_id &&
                    !assessment?.current_assessment?.has_submitted_review ? (
                      <ResumeUpload
                        assessment={assessment?.current_assessment}
                      />
                    ) : assessment?.current_assessment?.resume_id &&
                      !assessment?.current_assessment?.has_submitted_review ? (
                      <AssessmentReview
                        assessment={assessment?.current_assessment}
                      />
                    ) : (
                      <AssessmentConcluded
                        assessment={assessment?.current_assessment}
                      />
                    )}
                  </>
                )}
              </>
            ) : assessment?.current_assessment?.status ===
              AssessmentStatus.NOT_QUALIFIED ? (
              <AssessmentNotQualified />
            ) : (
              <AntiCheatContextWrapper>
                <CandidateAssessFlow />
              </AntiCheatContextWrapper>
            )}
          </>
        ) : (
          <UnavailableAssessment
            assessmentData={assessment?.current_assessment}
          />
        )}
      </>
    );
  } else {
    return <TestDetails setSideMenuExpand={props.setSideMenuExpand} />;
  }
}
